import { Button } from "components/Button/Button";
import { Icon } from "components/Icon/Icon";
import { IconCollection } from "components/Icon/IconCollection";
import "./Error.scss";

interface ErrorProps {
    isErrorBoundary?: boolean;
}

const Error = ({ isErrorBoundary }: ErrorProps) => {
    const icon = isErrorBoundary
        ? IconCollection.alertCircleOutline
        : IconCollection.imageBrokenVariant;
    return (
        <div className="error">
            <div className="error__wrapper">
                <Icon icon={icon} className="error__icon" />
                <div className="error__content">
                    {isErrorBoundary ? (
                        <>
                            <h1 className="error__title">Oops, something went wrong...</h1>
                            <div className="error__subtitle">
                                We are working on fixing the problem. Please refresh the page or go{" "}
                                <a href="/" title="Back to the dashboard">
                                    back to the dashboard
                                </a>
                            </div>
                        </>
                    ) : (
                        <>
                            <h1 className="error__title">
                                Sorry, we cannot find what you're looking for. Please check the
                                link.
                            </h1>
                            <Button href="/" label="Back to the dashboard" />
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Error;
